/**
 * Folder auth chain (nearest folder first) for the request an editor tab shows,
 * so Send resolves `inherit` through request → folders → collection exactly as
 * Run collection does (card 77f785cc). The sidebar record is the source of the
 * folder: a tab's own `folderId` is only set for some open paths, and a request
 * moved between folders keeps its tab.
 */
import { getFolderAuthChain } from './collectionFolders';
import { findSidebarRequest, resolveRequestTabCollectionId } from './requestResolve';

const NO_FOLDERS = [];

/**
 * The same chain for a request (a sidebar record or a live tab's state) whose
 * collection is already known — Generate Code, from the sidebar or the AI.
 */
export function folderAuthChainForRequest(request, collection) {
  if (!request || !collection) return NO_FOLDERS;
  const requestId = request.originalId ?? request.id ?? null;
  const record = requestId != null ? findSidebarRequest([collection], requestId) : null;
  const folderId = record?.folder_id ?? request.folder_id ?? request.folderId ?? null;
  return folderId ? getFolderAuthChain(collection, folderId) : NO_FOLDERS;
}

export function folderAuthChainForTab(tab, collections) {
  const collectionId = resolveRequestTabCollectionId(tab, collections);
  if (!collectionId) return NO_FOLDERS;
  const collection = (collections || []).find((c) => String(c.id) === String(collectionId));
  if (!collection) return NO_FOLDERS;
  const record = tab.originalId != null ? findSidebarRequest([collection], tab.originalId) : null;
  const folderId = record?.folder_id ?? tab.folderId ?? tab.folder_id ?? null;
  return folderId ? getFolderAuthChain(collection, folderId) : NO_FOLDERS;
}
